

import CustomImg from './custom-img.vue'//封装共用

const  CustomImgCom= {
  install: function (Vue) {
    Vue.component("CustomImg", CustomImg);
  }
}


export default CustomImg